module.exports = __webpack_public_path__ + "static/media/sgyhk.53f7e02e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/sgyhk.png
// module id = 2175
// module chunks = 0